<template>
  <div class="pre-checkout-sidebar-guest">
    <slot name="error"></slot>
    <div class="pre-checkout-sidebar-guest-title">
      <span class="pre-checkout-sidebar-guest-title-text">
        Συνέχεια ως επισκέπτης
      </span>
      <span class="pre-checkout-sidebar-guest-title-subtext">
        Συμπλήρωσε το email σου και προχώρησε στην αγορά σου πιο γρήγορα
      </span>
    </div>
    <form class="pre-checkout-sidebar-guest-form"
          accept-charset="utf-8"
          method="post"
          :action="previewOrderUrl"
    >
      <div class="form-group dioptra-input-wrapper">
        <input id="email"
               v-model="email"
               class="form-control dioptra-input-field"
               name="email"
               placeholder="Το email σου"
               required
               type="email"
        >
        <label class="customer-guest-form-label dioptra-input-label"
               for="email"
        >Email</label>
      </div>
      <button class="pre-checkout-sidebar-body-form-button submit-btn" name="preview_continue" type="submit" value="true">
        <span>Συνέχεια</span>
      </button>
    </form>
    <div class="pre-checkout-sidebar-guest-actions">
      <div class="pre-checkout-sidebar-guest-actions-return">
        <button class="pre-checkout-sidebar-guest-actions-return-button"
                name="return"
                value="return"
                @click="onReturnBackClick"
        >
          <span class="pos-rel pre-checkout-sidebar-guest-actions-return-button-text">Επιστροφή</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
  name: 'PreCheckoutSidebarGuest',
  data () {
    return {
      email: ''
    }
  },
  computed: {
    ...mapGetters([
      'config'
    ]),
    previewOrderUrl () {
      return `${this.config?.url?.base}preview_order${this.config?.url?.suffix}`
    }
  },
  methods: {
    onReturnBackClick () {
      this.$emit('return-back-click')
    }
  }
}
</script>

<style lang="scss" scoped>
.pre-checkout-sidebar-guest-form {
  margin-bottom: 30px;
}
.form-control {
  border: 1px solid #231F20;
  border-radius: unset;
  padding: 10px 25px;
  font-weight: 400;
  color: #231F20;
}
.pre-checkout-sidebar-guest {
  padding-left: 40px;
  padding-right: 40px;
  @media screen and (min-width:1200px) and (max-height:900px){
    margin-top:-45px
  }
  @media screen and (max-width: 767px) {
    padding-top: 150px
  }
}
.pre-checkout-sidebar-body-form-button {
  font-size: 19px;
  border-radius: unset;
  width: 100%;
  background-color: #8D7197;
  @media screen and (max-width: 767px) {
    font-size: 17px;
  }
}
.pre-checkout-sidebar-guest-title {
  display: grid;
  margin-bottom: 30px;
}
.pre-checkout-sidebar-guest-title-text {
  font-size: 24px;
  font-weight: 700;
  color: #231F20;
}
.pre-checkout-sidebar-guest-title-subtext {
  font-size: 13px;
  color: #231F20;
}
.pre-checkout-sidebar-guest-actions {
  display: grid;
  gap: 100px;
  align-items: center;
  align-content: space-between;
}
.pre-checkout-sidebar-guest-actions-return {
  display: grid;
  gap: 14px;
}
.pre-checkout-sidebar-guest-actions-return-button {
  width: 100%;
  background: #fff;
  color: #231F20;
  font-size: 15px;
  border: unset;
  text-align: start;
}
.pre-checkout-sidebar-guest-actions-return-button-text {
  display: flex;
  align-items: center;
  padding-left:25px;
  &:before {
    content:"";
    left:0;
    position: absolute;
    top:50%;
    transform: translateY(-50%) rotate(-45deg);
    width: 14px;
    height: 14px;
    border-top: 2px solid var(--prime1);
    border-left: 2px solid var(--prime1)
  }
}
</style>
